
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';

import { Shield, Lock, Eye, FileText, ChevronLeft } from 'lucide-react';

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen bg-[#050505] flex flex-col">
            <Navbar />

            <div className="flex-1 max-w-4xl mx-auto px-4 py-12 w-full">
                {/* Header */}
                <div className="mb-12">
                    <Link to="/" className="inline-flex items-center text-sm text-gray-400 hover:text-purple-400 mb-6 transition-colors">
                        <ChevronLeft className="w-4 h-4 mr-1" />
                        Back to Home
                    </Link>
                    <div className="flex items-center space-x-3 mb-4">
                        <div className="p-3 rounded-xl bg-purple-900/20 border border-purple-500/30">
                            <Shield className="w-8 h-8 text-purple-400" />
                        </div>
                        <h1 className="text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400">
                            Privacy Policy
                        </h1>
                    </div>
                    <p className="text-gray-400 text-lg">
                        Last updated: {new Date().toLocaleDateString()}
                    </p>
                </div>

                {/* Content */}
                <div className="space-y-12">
                    <Section
                        icon={Eye}
                        title="Overview"
                        content="At ComicMenia, we take your privacy seriously. This policy describes how we collect, use, and protect your personal data when you use our platform."
                    />

                    <Section
                        icon={FileText}
                        title="Information We Collect"
                        content={
                            <ul className="list-disc pl-5 space-y-2 text-gray-400 mt-4">
                                <li><strong className="text-gray-300">Account Information:</strong> Username, email address, and profile details you provide.</li>
                                <li><strong className="text-gray-300">Content:</strong> Comics, comments, and other content you upload or post.</li>
                                <li><strong className="text-gray-300">Usage Data:</strong> Information about how you interact with the platform, including reading history and interactions.</li>
                                <li><strong className="text-gray-300">Payment Information:</strong> Transaction history (we do not store credit card numbers directly; they are handled by our secure payment processors like Stripe and Razorpay).</li>
                            </ul>
                        }
                    />

                    <Section
                        icon={Lock}
                        title="How We Use Your Information"
                        content={
                            <div className="space-y-4 text-gray-400 mt-4">
                                <p>We use your information to:</p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>Provide, maintain, and improve our services.</li>
                                    <li>Process transactions and send related information.</li>
                                    <li>Send you technical notices, updates, security alerts, and support messages.</li>
                                    <li>Respond to your comments, questions, and requests.</li>
                                    <li>Monitor and analyze trends, usage, and activities in connection with our services.</li>
                                </ul>
                            </div>
                        }
                    />

                    <Section
                        icon={Shield}
                        title="Data Security"
                        content="We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, so we cannot guarantee absolute security."
                    />

                    <div className="pt-8 border-t border-white/5">
                        <h3 className="text-xl font-semibold text-white mb-4">Contact Us</h3>
                        <p className="text-gray-400">
                            If you have any questions about this Privacy Policy, please contact us at <a href="mailto:privacy@comicmenia.com" className="text-purple-400 hover:underline">privacy@comicmenia.com</a>.
                        </p>
                    </div>
                </div>
            </div>


        </div>
    );
};

const Section = ({ icon: Icon, title, content }) => (
    <div className="bg-[#0a0a0a] rounded-2xl p-8 border border-white/5 hover:border-purple-500/20 transition-colors">
        <div className="flex items-center space-x-3 mb-6">
            <Icon className="w-6 h-6 text-purple-400" />
            <h2 className="text-2xl font-semibold text-white">{title}</h2>
        </div>
        <div className="text-gray-400 leading-relaxed">
            {content}
        </div>
    </div>
);

export default PrivacyPolicy;
